import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {API_URL} from './token.service';

import 'rxjs/add/operator/filter';

@Injectable()
export class _RuleLiquidityProviderService{

  constructor(private http: HttpClient){ }

  getLiquidityProviders(ruleType){
    return this.http.get<any[]>(`${API_URL}/rule-liquidity-providers/rule-type/` + ruleType).toPromise().then(function(response){
      var providers = response;
      for(var i = 0;i<providers.length;i++){
        if(providers[i].accountId == null){
          providers[i].entityType = 'all';
          providers[i].accountId = 0;
        }else{
          providers[i].entityType = 'ACCOUNT';
        }
      }
      return providers;
    });
  }

  createLiquidityProvider(ruleLiquidityProvider){
    if(ruleLiquidityProvider.entityType == 'all'){
      ruleLiquidityProvider.accountId = null;
    }
    return this.http.post(`${API_URL}/rule-liquidity-providers`, [ ruleLiquidityProvider ]);
  }

  updateLiquidityProvider(ruleLiquidityProvider){
    if(ruleLiquidityProvider.entityType == 'all'){
      ruleLiquidityProvider.accountId = null;
    }
    return this.http.put(`${API_URL}/rule-liquidity-providers`, [ ruleLiquidityProvider ]);
  }

  deleteLiquidityProvider(ruleLiquidityProviderId){
    return this.http.delete(`${API_URL}/rule-liquidity-providers/` + ruleLiquidityProviderId);
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/services/ruleLiquidityProvider.service.ts